module.exports = __webpack_public_path__ + "img/liuzhigao.3d8215cb.jpg";